import { useQuery } from "react-query";
import { fetchWebhooksList } from '@api/notificationChannel';

function useFetchWebhooksList({
    context = 'app',
}) {
    const queryKey = ['webhooksListData', { context }];

    const { data = null, error, isLoading } = useQuery(queryKey, async () => {
        const response = await fetchWebhooksList({
            context,
        });
        return response.data;
    }
    );
    return { data, error, isLoading };
}

export default useFetchWebhooksList;
